import { lazy, Suspense } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { BeltType } from '../../model/model'
import useWidth from '../../hooks/useWidth'
import { useAppSelector } from '../../store/store'

const BeltSelectorMobile = lazy(() => import('../BeltSelectorMobile/BeltSelectorMobile'))
const BeltSelectorDesktop = lazy(() => import('../BeltSelectorDesktop/BeltSelectorDesktop'))

const Navigation = () => {
  const width = useWidth()
  const navigate = useNavigate()
  const { userID } = useParams()
  const beltIDMap = useAppSelector((store) => store.belt.idMap)

  const handleChangeBelt = async (obj: BeltType) => {
    navigate((userID ? `/user/${userID}` : '') + `/${beltIDMap[obj.id]}`)
  }

  return (
    <Suspense fallback=''>
      {width && width < 801 ? <BeltSelectorMobile onChange={handleChangeBelt} /> : <BeltSelectorDesktop />}
    </Suspense>
  )
}

export default Navigation
